import { Certificate, NoCertificate } from 'Images/index';
import { Content, TextContainer, mainText, subText, altMainText, altSubText } from '../style';
import { userSelector } from 'Redux/LoggedUserSlice';
import { useSelector } from 'react-redux';
import { handleDownloadCertificate } from 'Utils/handle-download-certificate';

const CertificateContent = ({ certification, userName, course, t2 }) => {
  const { id: userId } = useSelector(userSelector);
  const hasCertificate = certification?.id !== null;

  const textContent = hasCertificate ? (
    <>
      <div style={mainText}>{t2('HasCertificateMainText')}</div>
      <div style={subText}>{t2('HasCertificateSubText')}</div>
    </>
  ) : (
    <>
      <div style={altMainText}>{t2('NoCertificateMainText')}</div>
      <div style={altSubText}>{t2('NoCertificateSubText')}</div>
    </>
  );

  if (hasCertificate) {
    return (
      <Content
        style={{ cursor: 'pointer' }}
        onClick={async () => {
          const certificateId = certification.id;
          const courseId = course?.id;
          const filename = `certificado_${userName}_.pdf`;
          handleDownloadCertificate(courseId, userId, certificateId, filename);
        }}
      >
        <img src={Certificate} alt={t2('Certificate')} />
        <TextContainer>{textContent}</TextContainer>
      </Content>
    );
  }

  return (
    <Content>
      <img src={NoCertificate} alt={t2('NoCertificate')} />
      <TextContainer>{textContent}</TextContainer>
    </Content>
  );
};

export default CertificateContent;
